import React from 'react';
import { motion } from 'framer-motion';

/* ================================
   CONFIGURACIÓN RESPONSIVA DEL LOGO
   clamp(min, ideal, max)
   ================================ */
const LOGO_SIZE = {
  small: 'clamp(80px, 18vw, 140px)',
  medium: 'clamp(350px, 30vw, 260px)',
  large: 'clamp(180px, 40vw, 360px)',
  xlarge: 'clamp(220px, 45vw, 500px)',
};

const Logo = ({
  size = 'large',
  className = ''
}) => {
  return (
    <motion.div
      className={`flex justify-center items-center ${className}`}
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.6 }}
    >
      <img
        src="/assets/logo.png"
        alt="Logo"
        draggable={false}
        style={{
          width: LOGO_SIZE[size],
          height: 'auto',
          maxWidth: 'none'
        }}
      />
    </motion.div>
  );
};

export default Logo;
